import { Component, OnInit } from '@angular/core';
import { ApplicationActions } from '@jms/tenant/module.jms.state';
import { UtilService } from '@jms/utils/util.services';


@Component({
    selector: 'authorise',
    template: `
    <div class="splash">
        <div class="splash-text">
            <span class="jms"><img src="/images/WorkBuddy.svg" /></span>
        </div>
    </div>
    `,
    standalone: false
})
export class AuthoriseComponent implements OnInit {
  constructor(private actions: ApplicationActions) { }

  ngOnInit() {
    const domain = UtilService.getLocation().hostName;
    const token = UtilService.getURLParameter('token');
    let returnUrl = UtilService.getURLParameter('returnUrl');
    if (returnUrl) {
      returnUrl = decodeURIComponent(UtilService.getURLParameter('returnUrl'));
    }
    if (token) this.actions.loginAuthorise(token, domain, returnUrl);
  }
}
